import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AdminNav from "../../Components/AdminNav.jsx/AdminNav";
import MenuFilter2 from "../../Components/MenuFilter/MenuFilter2";
import CompletedRow from "../../Components/QueueRow/CompletedRow";
import "./OrderCompleted.css";

const OrderCompleted = () => {
  const  [orders, setOrders] = useState([]);
  const  [ogOrders, setOGOrders] = useState([]);
   const [amount, setAmount] = useState("");
   const [loading, setLoading] = useState(true);
   const [bizCategories, setBizCategories] = useState([]);
   const [currentBizCategories, setCurrentBizCategories] = useState([]);
  //  let x = axios.get("/completeTicket");

   useEffect(() => {
     const orderQueue = (list) => {
       let queue = list;
       queue.sort(function(a, b){
         return (a.completed > b.completed) ? -1 : ((a.completed < b.completed) ? 1 : 0)
     })
        let amountInQueue = queue.length;
        // let queueX = queue.reverse()
        setAmount(amountInQueue)
        setOrders(queue);
        setOGOrders(queue);
        const categoriesSet = [
         ...new Set(
           queue.map((bizItem) => bizItem.data.category.toUpperCase())
         ),
       ];
       setBizCategories(categoriesSet);
       setCurrentBizCategories(categoriesSet);
       setLoading(false)
     }
     const initializeMenu = async () => {
       try {
         const response = await axios.get("/completeTicket");
        orderQueue(response.data)
       } catch (err) {
         console.log(err);
         setLoading(false);
       }
     };

         initializeMenu();

     // eslint-disable-next-line
   }, []);
 
   const filterBizByCategory = (category) => {
     if (category === "ALL") {
       setCurrentBizCategories(bizCategories);
       setOrders(ogOrders)
     } else {
       setCurrentBizCategories([category]);
       let queue = ogOrders;
       const queueFilter = queue.filter(item => item.data.category.toUpperCase() === category);
       setOrders(queueFilter)
     }
   };
 
 
   
   if(loading)return null;
 

  return (
    <>
      <AdminNav />
      <MenuFilter2
        menuCategories={bizCategories}
        handleClick={filterBizByCategory}
      />
      <div className="order-wrapper">
        <div className="row s12">
          <div className="col s6 center">
              <p className="queue-total">Total Completed: <small className="total-num submit-button ">{amount}</small></p>
          </div>
          <div className="order-padding col s6 center">
             <Link to={"/admin/orders"} > <button className=" btn submit-button queue-complete">Current Queue</button>
               </Link>
          </div>
        </div>
        <table className="left">
          <thead>
            <tr>
            <th className="table-col">Date</th>
              <th className="table-col">Name</th>
              <th className="table-col">Service</th>
              <th className="table-col">Phone Number</th>
              <th className="table-col">Check-in</th>
              <th className="table-col">Elasped</th>
              <th className="table-col">Delete</th>
            </tr>
          </thead>
        </table>
        {orders.map((orderItems) => {
          return (
            <React.Fragment>
             <CompletedRow orderItems={orderItems}/>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default OrderCompleted;
